export function heroVideo() {
    const lazyVideo = document.querySelectorAll('video');
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            const video = entry.target;
            if (entry.isIntersecting && !video.classList.contains('paused')) {
                if (video.querySelector('source').getAttribute('data-src') !== null) {
                    const source = entry.target.querySelector('source').getAttribute('data-src')
                    video.setAttribute('src', source);
                    video.play();
                }
            } else {
                video.pause();
            }
        });
    });

    lazyVideo.forEach(video => {
        if (document.body.classList.contains('no-touch')) {
            observer.observe(video);
        }
    });

    $('.video-actions-button').on('click', function (e) {
        e.preventDefault();
        const $this = $(this);
        const video = $this.closest('.hero-section').find('video');

        video[0].paused ? video[0].play() : video[0].pause();

        $this.toggleClass('paused');
        if ($this.hasClass('paused')) {
            video.addClass('paused');
            $this.find('span').text('Play video');
        } else {
            video.removeClass('paused');
            $this.find('span').text('Pause video');
        }
    });

    $('.wistia_responsive_padding').trigger('click');
}


// WEBPACK FOOTER //
// ./assets/js/modules/heroVideo.js